/* eslint-disable no-template-curly-in-string */
import React, { FC, useState } from 'react';
import { Grid, Button, TextField, Box, Typography } from '@mui/material';
import { SubTitle, LoadingSpinner } from '@components';
import { useAppDispatch } from '@hooks/redux-custom';
import { useGetSMSTemplatesQuery, useUpdateSMSTemplateMutation } from '@services';
import { showToast } from '@store/slices/notification';

const SMSTemplate: FC = () => {
  const { data, isFetching, refetch } = useGetSMSTemplatesQuery();
  const [updateSMS, { isLoading }] = useUpdateSMSTemplateMutation();
  const [smsTemplate, setSMSTemplate] = useState(data?.template);
  const dispatch = useAppDispatch();

  const onSaveSMS = async () => {
    const confirmData = await updateSMS({
      id: data?.id,
      template: smsTemplate,
    });

    if (confirmData) {
      dispatch(
        showToast({
          message: `Successfully updated the sms template!`,
          type: 'success',
        }),
      );

      refetch();
    }
  };

  if (isFetching || isLoading) return <LoadingSpinner isOpen={isFetching || isLoading} />;

  return (
    <>
      <SubTitle title="SMS Template" />
      <Box p={2}>
        <Grid container spacing={2} data-testid="sms-template">
          <Grid item xs={12}>
            <TextField
              multiline
              rows={5}
              value={smsTemplate}
              defaultValue={data?.template}
              fullWidth
              placeholder="Enter SMS message..."
              name="message"
              onChange={(e) => setSMSTemplate(e.target.value)}
              inputProps={{ 'data-testid': 'sms-template-input' }}
            />
          </Grid>
          <Grid item xs={2}></Grid>
          <Grid item xs={10}>
            <Typography variant="body1">use the following placeholder to replace with actual value</Typography>
            <Typography variant="subtitle1">
              {'${username}'}, {'${phone_number}'}, {'${email}'}
            </Typography>
          </Grid>
          <Grid item xs={10}></Grid>
          <Grid item xs={2}>
            <Button variant="contained" fullWidth type="submit" data-testid="save-button" onClick={onSaveSMS}>
              Save Template
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default SMSTemplate;
